import React from "react";
import LinkedShowLines from "./LinkedShowElement";
import { routes } from "utilities/routing/generatedRoutes";
import { Dot } from "components/Dot";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";

interface Props {
  shows: server.dto.LinkedShow[]
}

const LinkedShowsList = (props: Props) => {
  const { shows } = props;

  // Workaround for train detail page, as there we don't have preview panels
  const onClick = (showId: number) => {
    if (document.getElementsByClassName("side-panel-root").length === 0) {
      window.location.href = routes.show_Detail(showId).absolute;
    }
  }

  return <div className="flex-column gap-small">
    {shows.map(show => (
      <ShowSidePanel
        canEdit
        showId={show.showId}
        key={show.showId}
        trigger={<a className="flex gap-small linked-show-row linked-show-link regular" onClick={() => onClick(show.showId)} style={{ cursor: "pointer", textDecoration: "none" }}>
          <div>
            <Dot color={show.status.hexColor} />
          </div>
          <div>
            <LinkedShowLines {...show} format={"regular"} />
          </div>
        </a>}
      />))
    }
  </div >;
};

export default LinkedShowsList;
